module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1m6xV"))).then(() => parcelRequire('hEqeo'));